<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Copyright Mofoter Pro. All Rights Reserved.
            </div>
            <div class="col-sm-6">
           
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by  <a href="https://elitedigital.ai/" target="_blank">Elite Digital Technologies</a>
                </div>
            </div>
        </div>
    </div>
</footer>